import { render, staticRenderFns } from "./Matrix2.vue?vue&type=template&id=1bf67d27&scoped=true"
import script from "./Matrix2.vue?vue&type=script&lang=js"
export * from "./Matrix2.vue?vue&type=script&lang=js"
import style0 from "./Matrix2.vue?vue&type=style&index=0&id=1bf67d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf67d27",
  null
  
)

export default component.exports